__turbopack_context__.v({
  "alloysLoremIpsum": "resource-grid-module__tPLFdW__alloysLoremIpsum",
  "beyondTheBasics": "resource-grid-module__tPLFdW__beyondTheBasics",
  "blogGrid": "resource-grid-module__tPLFdW__blogGrid",
  "blogGridContainer": "resource-grid-module__tPLFdW__blogGridContainer",
  "blogGridEyebrow": "resource-grid-module__tPLFdW__blogGridEyebrow",
  "blogGridHeading": "resource-grid-module__tPLFdW__blogGridHeading",
  "blogGridTitle": "resource-grid-module__tPLFdW__blogGridTitle",
  "button": "resource-grid-module__tPLFdW__button",
  "cards": "resource-grid-module__tPLFdW__cards",
  "caseStudyGrid": "resource-grid-module__tPLFdW__caseStudyGrid",
  "chevronLeftLarge": "resource-grid-module__tPLFdW__chevronLeftLarge",
  "chevronRightLarge": "resource-grid-module__tPLFdW__chevronRightLarge",
  "chevronRightSmall": "resource-grid-module__tPLFdW__chevronRightSmall",
  "container": "resource-grid-module__tPLFdW__container",
  "content": "resource-grid-module__tPLFdW__content",
  "contentGroup": "resource-grid-module__tPLFdW__contentGroup",
  "dieCastingResources": "resource-grid-module__tPLFdW__dieCastingResources",
  "dots": "resource-grid-module__tPLFdW__dots",
  "grid": "resource-grid-module__tPLFdW__grid",
  "navigation": "resource-grid-module__tPLFdW__navigation",
  "navigationWrapper": "resource-grid-module__tPLFdW__navigationWrapper",
  "nextButton": "resource-grid-module__tPLFdW__nextButton",
  "overviewGrid": "resource-grid-module__tPLFdW__overviewGrid",
  "pagination": "resource-grid-module__tPLFdW__pagination",
  "paginationButton": "resource-grid-module__tPLFdW__paginationButton",
  "paginationButton1": "resource-grid-module__tPLFdW__paginationButton1",
  "paginationDotIcon": "resource-grid-module__tPLFdW__paginationDotIcon",
  "paginationDotIcon1": "resource-grid-module__tPLFdW__paginationDotIcon1",
  "paginationDotIcon2": "resource-grid-module__tPLFdW__paginationDotIcon2",
  "paginationDotIcon3": "resource-grid-module__tPLFdW__paginationDotIcon3",
  "paginationWrapper": "resource-grid-module__tPLFdW__paginationWrapper",
  "prevButton": "resource-grid-module__tPLFdW__prevButton",
  "resourceCarouselTitle": "resource-grid-module__tPLFdW__resourceCarouselTitle",
  "resourceGrid": "resource-grid-module__tPLFdW__resourceGrid",
  "resourceGridContainer": "resource-grid-module__tPLFdW__resourceGridContainer",
  "resourceGridMargin": "resource-grid-module__tPLFdW__resourceGridMargin",
  "resourceGridTitle": "resource-grid-module__tPLFdW__resourceGridTitle",
  "sentencesAboutCompany": "resource-grid-module__tPLFdW__sentencesAboutCompany",
  "slide": "resource-grid-module__tPLFdW__slide",
  "title": "resource-grid-module__tPLFdW__title",
  "viewAll": "resource-grid-module__tPLFdW__viewAll",
});
